import React from 'react';
import { Card, CardBody, Table, Badge } from 'reactstrap';
import { toast } from 'react-toastify';

import { formatDateTime } from '../../formatters';
import { DOC_SOURCE_BADGE } from '../invitationInternalConstants';
import * as api from '../invitationInternalApi';

// Invitation - Internal > Supporting Document tab — VIEW ONLY.
//
// Documents uploaded during Planning and Procurement. Unlike the external/DMUT
// view there is NO showToDmut filter — the committee sees every attachment. Each
// row offers a Preview action (DOD).
//
// Preview needs the file bytes, which do not exist while the module is
// dummy-backed (TODO(API)) — the api layer rejects with an explanatory message
// and the action surfaces it rather than appearing to succeed.
const SupportingDocumentTab = ({ invitationId, detail }) => {
  const docs = detail?.supportingDocuments || [];

  const handlePreview = async doc => {
    try {
      const blob = await api.downloadDocument(invitationId, doc.id);
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.info(`Preview unavailable: ${error}`);
    }
  };

  return (
    <div>
      <div className='mb-3'>
        <h5 className='mb-1'>
          <i className='ri-file-text-line me-2'></i>
          Supporting Documents
        </h5>
        <p className='text-muted mb-0 fs-12'>
          Documents from the Planning and Procurement stages.
        </p>
      </div>

      <Card className='border shadow-none'>
        <CardBody className='p-0'>
          <div className='table-responsive'>
            <Table className='table-sm align-middle mb-0'>
              <thead className='table-light'>
                <tr>
                  <th>Document Name</th>
                  <th>Source</th>
                  <th>Last Updated</th>
                  <th className='text-center'>Action</th>
                </tr>
              </thead>
              <tbody>
                {docs.length === 0 ? (
                  <tr>
                    <td colSpan={4} className='text-center text-muted py-3'>
                      No documents
                    </td>
                  </tr>
                ) : (
                  docs.map(d => (
                    <tr key={d.id}>
                      <td>
                        <i className='ri-file-2-line text-muted me-2'></i>
                        {d.name}
                      </td>
                      <td>
                        <Badge
                          color={DOC_SOURCE_BADGE[d.source] || 'secondary'}
                          className='px-2'
                        >
                          {d.source}
                        </Badge>
                      </td>
                      <td>{formatDateTime(d.lastUpdated)}</td>
                      <td className='text-center'>
                        <button
                          className='btn btn-soft-secondary btn-sm'
                          title='Preview'
                          onClick={() => handlePreview(d)}
                        >
                          <i className='ri-eye-line align-bottom me-1'></i>
                          Preview
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default SupportingDocumentTab;
